import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { addDaysToDateString } from "@/lib/missing-hours";

interface PostponeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Dagens forfall (YYYY-MM-DD); ny dato må være senere. */
  currentDue: string;
  pending?: boolean;
  onSubmit: (input: { newDue: string; note: string | null }) => void;
}

export default function PostponeDialog({ open, onOpenChange, currentDue, pending, onSubmit }: PostponeDialogProps) {
  const minDate = addDaysToDateString(currentDue, 1);
  const [newDue, setNewDue] = useState(minDate);
  const [note, setNote] = useState("");

  useEffect(() => {
    if (open) {
      setNewDue(addDaysToDateString(currentDue, 1));
      setNote("");
    }
  }, [open, currentDue]);

  const valid = !!newDue && newDue >= minDate;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Utsett oppfølgingen</DialogTitle>
          <DialogDescription>Velg ny forfallsdato. Oppfølgingen forblir åpen.</DialogDescription>
        </DialogHeader>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (valid) onSubmit({ newDue, note: note.trim() || null });
          }}
        >
          <div className="space-y-4 py-2">
            <div className="space-y-1.5">
              <Label htmlFor="postpone-date">Ny dato</Label>
              <Input id="postpone-date" type="date" value={newDue} min={minDate} onChange={(e) => setNewDue(e.target.value)} />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="postpone-note">Notat (valgfritt)</Label>
              <Textarea id="postpone-note" value={note} onChange={(e) => setNote(e.target.value)} rows={3} placeholder="Hvorfor utsettes den?" />
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Avbryt
            </Button>
            <Button type="submit" disabled={!valid || pending}>
              {pending ? "Utsetter ..." : "Utsett"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
